import {Component, effect, inject, Input, OnInit, ViewChild} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {GenericListComponent} from '../../../../../../components/generic/generic-list/generic-list.component';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {MessageComponent} from '../../../../../../components/generic/message/message.component';
import {ConfirmationService, PrimeTemplate} from 'primeng/api';
import {PlayerProfile} from '../../../../model/player-profile';
import {DialogService} from 'primeng/dynamicdialog';
import {RestErrorHelper} from '../../../../../../helper/rest-error-helper';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {ErrorType} from '../../../../../../model/error-type';
import {ColumnType} from '../../../../../../components/generic/generic-list/columnType';
import {Payment} from '../../../../model/payment';
import {Domains} from '../../../../../../../assets/domains/domains';
import {
  DOMAIN_CD_PAYMENT_STATUS,
  DOMAIN_CD_PAYMENT_TYPE, DOMAIN_CD_VENDOR, DOMAIN_VALUES_PAYMENT_STATUS,
  DOMAIN_VALUES_PAYMENT_TYPES, DOMAIN_VALUES_VENDOR, PAYMENT_STATUS_EXPIRED, PAYMENT_STATUS_PENDING
} from '../../../../model/player-profile.domains';
import {
  PlayerProfilePaymentStatusComponent
} from '../player-profile-account-data/player-profile-payment-status/player-profile-payment-status.component';
import {Divider} from 'primeng/divider';
import {Button} from 'primeng/button';
import {ViewService} from '../../../../../shared/service/view.service';
import {
  PlayerProfileFeaturesDialogComponent
} from '../../../player-profile-register/features/player-profile-features-dialog/player-profile-features-dialog.component';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {PlayerProfileServerSettings} from '../../../../model/player-profile-server-settings';
import {CurrencyPipe, DatePipe, DecimalPipe, NgTemplateOutlet} from '@angular/common';
import {DateHelper} from '../../../../../../helper/date.helper';
import {DomainValuePipe} from '../../../../../../pipes/domain-value.pipe';
import {environment} from '../../../../../../../environments/environment';
import {RouterLink} from '@angular/router';
import {FrontendNotificationService} from '../../../../../frontend/service/frontend-notification.service';
import {FlutterService} from '../../../../../../services/app/flutter.service';
import {SubsriptionStatus} from '../../../../model/app/subsription-status';
import {PrivacyPolicyComponent} from '../../../../../shared/legal/privacy-policy/privacy-policy.component';

@Component({
  selector: 'app-player-profile-account-payments',
  standalone: true,
  imports: [
    TranslatePipe,
    GenericListComponent,
    LoadingComponent,
    MessageComponent,
    PrimeTemplate,
    PlayerProfilePaymentStatusComponent,
    Divider,
    Button,
    InfoTextComponent,
    DecimalPipe,
    DatePipe,
    CurrencyPipe,
    DomainValuePipe,
    RouterLink,
    NgTemplateOutlet
  ],
  templateUrl: './player-profile-account-payments.component.html',
  styleUrl: './player-profile-account-payments.component.scss'
})
export class PlayerProfileAccountPaymentsComponent implements OnInit
{
  private frontendNotificationService = inject(FrontendNotificationService);
  private flutterService = inject(FlutterService);
  private confirmationService = inject(ConfirmationService);
  public view = inject(ViewService);
  private translate = inject(TranslateService);
  private dialogService = inject(DialogService);
  private restErrorHelper = inject(RestErrorHelper);
  private playerProfileService = inject(PlayerProfileService);

  @ViewChild('paymentDetailsTemplate') paymentDetailsTemplate: any;
  @ViewChild('paymentStatusTemplate') paymentStatusTemplate: any;

  @Input() playerProfile: PlayerProfile;

  system = this.frontendNotificationService.system;
  isLoading: boolean;
  errorMsg: ErrorType;

  settings: PlayerProfileServerSettings;
  isLoadingSettings: boolean;
  errorMsgSettings: ErrorType;
  missingPersonalData: boolean;

  showPurchase: boolean;
  showPurchaseIOS: boolean;
  isPurchasing: boolean;
  errorMsgPurchase: ErrorType;

  columns: any[];
  columnsMobile: ColumnType[];

  payments: Payment[];
  appleSubsriptionStatus: SubsriptionStatus;
  appleSubscrptionActiveAndValid: boolean;
  hasExpiredOrPedingItems: boolean;

  constructor()
  {
    effect(() => {
      this.subscriptionStatusChanged(this.frontendNotificationService.subscriptionStatus());
    });
  }

  ngOnInit(): void
  {
    this.loadSettings();
    this.loadData();

    console.log('PAY: ' + this.playerProfile.account?.paymentDateTo);
    const now = new Date();
    const paymentDateBeforeNow = this.playerProfile.account.paymentDateTo ?
      (new Date(this.playerProfile.account.paymentDateTo).getTime() < new Date().getTime()) : false;
    const datePaymentDateTo = new Date(this.playerProfile.account.paymentDateTo);
    const diffs = DateHelper.getDaysDiffToNow(datePaymentDateTo);

    this.showPurchase = (environment.local || !this.playerProfile.account?.paymentDateTo || diffs < 90 || paymentDateBeforeNow) && this.system() !== 'ios';
    this.showPurchaseIOS = this.system() === 'ios';
    // this.appleSubsriptionStatus = this.playerSessionService.subsriptionStatus;
    // this.subscriptionStatusChanged()
    console.log('showPurchase: ' + this.showPurchase + ', diff: ' + diffs);
      // new Date(this.playerProfile.account.paymentDateTo) < DateHelper.getDaysDiffToNow()
  }

  private subscriptionStatusChanged(subscriptionStatus: SubsriptionStatus): void
  {
    this.appleSubsriptionStatus = subscriptionStatus;
    this.appleSubscrptionActiveAndValid = this.appleSubsriptionStatus?.isActive &&
      this.appleSubsriptionStatus?.expiresDate &&
      new Date(this.appleSubsriptionStatus.expiresDate).getDate() >= new Date().getDate();
    console.log('appleSubscrptionActiveAndValid: ', this.appleSubscrptionActiveAndValid);
    console.log('appleSubsriptionStatus: ', this.appleSubsriptionStatus);
  }

  private initColumns(): void
  {
    if (this.columns)
      return;

    // DATE
    // DOMAIN_VALUES_PAYMENT_TYPES
    this.columns = [
      { header: 'DATE', field: 'date', datatype: 'datetime', width: '125', sortable: true, class: 'text-center' }
    ];

    if (this.system() === 'ios')
    {
      this.columns.push(
        { header: 'VENDOR', field: 'vendorCd', datatype: 'domainValue', width: '', sortable: false, class: 'text-center',
          domainCd: DOMAIN_CD_VENDOR,
          domainValues: Domains.initializeListWithAllAndValues(DOMAIN_VALUES_VENDOR, this.translate)
        });
    }
    else this.columns.push({ header: 'AMOUNT', field: 'amount', datatype: 'currency', width: '80', sortable: false, class: 'text-center' });

    this.columns.push(
      { header: 'ACCOUNT', field: 'typeCd', datatype: 'domainValue', width: '120', sortable: false, class: 'text-center',
        domainCd: DOMAIN_CD_PAYMENT_TYPE,
        domainValues: Domains.initializeListWithAllAndValues(DOMAIN_VALUES_PAYMENT_TYPES, this.translate)},
      { header: 'TIMESPAN', field: 'paymentMonthsDays', datatype: '', width: '100', sortable: false, class: 'text-center' },
      { header: 'DATE_TO', field: 'paymentDateTo', datatype: 'date', width: '80', sortable: false, class: 'text-center' },
      /*{ header: 'STATUS', field: 'paymentStatus', datatype: 'domainValue', width: '', sortable: false, class: 'text-center',
        domainCd: DOMAIN_CD_PAYMENT_STATUS,
        domainValues: Domains.initializeListWithAllAndValues(DOMAIN_VALUES_PAYMENT_STATUS, this.translate)},*/
      {
        header: 'STATUS', datatype: 'template', template: this.paymentStatusTemplate, class: 'text-center'
      },
      {
        header: 'DETAILS', datatype: 'template', template: this.paymentDetailsTemplate
      },
      /*{ header: 'TYPE', field: 'accountCd', datatype: 'domainValue', width: '', sortable: false, class: 'text-center',
        domainCd: DOMAIN_CD_PAYMENT_ACCOUNT,
        domainValues: Domains.initializeListWithAllAndValues(DOMAIN_VALUES_PAYMENT_ACCOUNTS, this.translate)}*/
    );

    this.columnsMobile = [
      {
        key: 'PAY',
        header: 'PAYMENTS'
      }
    ];
  }

  public loadData(): void
  {
    this.errorMsg = undefined;
    this.isLoading = true;
    this.playerProfileService.getPayments().subscribe({
      next: data =>
      {
        console.log('Payments erhalten', data);
        this.payments = data;
        this.initColumns();
        this.initData();
        this.isLoading = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.missingPersonalData = error?.error?.message === 'PAYMENT_NOT_POSSIBLE_MISSING_PERSONAL_DATA';
        this.isLoading = false;
        this.errorMsg = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  private initData(): void
  {
    this.hasExpiredOrPedingItems = false;

    if (this.payments?.length > 0)
    {
      for (const payment of this.payments)
      {
        if (payment.paymentStatus === PAYMENT_STATUS_PENDING || payment.paymentStatus === PAYMENT_STATUS_EXPIRED)
        {
          this.hasExpiredOrPedingItems = true;
          break;
        }
      }
    }
  }

  private loadSettings(): void
  {
    this.errorMsgSettings = undefined;
    this.isLoadingSettings = true;
    this.settings = undefined;
    this.playerProfileService.loadSettings().subscribe({
      next: response =>
      {
        console.log('Einstellungen geladen', response);
        this.isLoadingSettings = false;
        this.settings = response;
      },
      error: (error) =>
      {
        this.isLoadingSettings = false;
        this.errorMsgSettings = this.restErrorHelper.getErrorType(error);
      }
    });
  }

  public openPlayerProfileFeatures(): void
  {
    PlayerProfileFeaturesDialogComponent.showDialog(this.dialogService, this.translate);
  }

  public buyProAccount12Months(): void
  {
    this.isPurchasing = true;
    this.errorMsgPurchase = undefined;
    this.playerProfileService.purchaseProAccount().subscribe({
      next: data =>
      {
        console.log('Kauf Pro-Version gestartet', data);
        if (data.checkoutUrl)
        {
          if (this.frontendNotificationService.runsInApp() && this.frontendNotificationService.system() === 'android')
          {
            this.flutterService.openCustomUrl(data.checkoutUrl);
          }
          else
          {
            window.location.href = data.checkoutUrl;
          }
        }
        this.isPurchasing = false;
      },
      error: error =>
      {
        console.log('error', error);
        this.isPurchasing = false;
        this.errorMsgPurchase = this.restErrorHelper.getErrorType(error);
        this.loadData();
      }
    });
  }

  public buyProAccountApple(): void
  {
    this.isPurchasing = true;
    this.flutterService.buyProAccountApple();
    setTimeout(() => this.isPurchasing = false, 3000);
  }

  public managerProAccountApple(): void
  {
    this.isPurchasing = true;
    this.flutterService.manageProAccountApple();
    setTimeout(() => this.isPurchasing = false, 3000);
  }

  public openPrivacyPolicy(): void
  {
    PrivacyPolicyComponent.showDialog(this.dialogService, this.translate);
  }

  public createInvoice(item: any): void
  {
    console.log('createInvoice', item);
    item.customButtonDisabled = true;
    const filename = this.translate.instant('INVOICE').toLowerCase() + '_' + item.id + '.pdf';
    this.playerProfileService.downloadInvoice(item.id, filename, item);
  }

  public deleteItem(payment: Payment): void
  {
    console.log('deleteItem: ', payment);
    if (payment.id > 0)
    {
      this.confirmationService.confirm({
        message: this.translate.instant('MSG_DELETE_SELECTED_ITEM'),
        header: this.translate.instant('MSG_HEADER_DELETE_ENTRY'),
        icon: 'pi pi-question-circle',
        acceptLabel: this.translate.instant('YES'),
        rejectLabel: this.translate.instant('NO'),
        rejectButtonStyleClass: 'button-no button-right',
        accept: () =>
        {
          this.isLoading = true;
          this.playerProfileService.deletePayment(payment.id).subscribe({
            next: () => this.loadData(),
            error: error =>
            {
              console.log('error', error);
              this.isLoading = false;
              this.restErrorHelper.handleErrorService(error);
            }
          });
        }
      });
    }
  }
}
